import request from "@/utils/request";

export function getWidget(data) {
  return request({
    url: "/dashboard/get-widget",
    method: "post",
    data
  });
}
